import React from 'react';
import AsyncSelect from 'react-select/async';
import { useStudentSelector } from './use-student-selector';

export const StudentSelector = ({
    courseId
}) => {
    const studentSelector = useStudentSelector({ courseId });
    return (
        <AsyncSelect
            isClearable={true}
            isSearchable={true}
            name="student"
            noOptionsMessage={() => 'None found with this filter'}
            cacheOptions
            defaultOptions
            placeholder='Type to search'
            loadOptions={studentSelector.retrieveStudents}
            onChange={studentSelector.onChange}
            isDisabled={studentSelector.isLoading}
            isLoading={studentSelector.isLoading}
        />
    )
}